var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#123312",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1139_885)"
  }, /*#__PURE__*/React.createElement("path", {
    color: "rgb(123, 134, 140)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0C0.671573 0 0 0.671573 0 1.5V12.5C0 13.3284 0.671573 14 1.5 14H4.5C4.91421 14 5.25 13.6642 5.25 13.25C5.25 12.8358 4.91421 12.5 4.5 12.5H2C1.72386 12.5 1.5 12.2761 1.5 12V2C1.5 1.72386 1.72386 1.5 2 1.5H5.25C5.40738 1.5 5.55557 1.5741 5.65 1.7L6.85 3.3C6.94443 3.4259 7.09262 3.5 7.25 3.5H14C14.2761 3.5 14.5 3.72386 14.5 4V7.5C14.5 7.91421 14.8358 8.25 15.25 8.25C15.6642 8.25 16 7.91421 16 7.5V3.5C16 2.67157 15.3284 2 14.5 2H7.5L6.45 0.6C6.16672 0.222291 5.72214 0 5.25 0H1.5Z",
    fill: "#7b868c"
  }), /*#__PURE__*/React.createElement("path", {
    color: "rgb(123, 134, 140)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7197 11.2803C12.4268 10.9874 12.4268 10.5126 12.7197 10.2197C13.0126 9.92678 13.4874 9.92678 13.7803 10.2197L15.7803 12.2197C16.0732 12.5126 16.0732 12.9874 15.7803 13.2803L13.7803 15.2803C13.4874 15.5732 13.0126 15.5732 12.7197 15.2803C12.4268 14.9874 12.4268 14.5126 12.7197 14.2197L14.1893 12.75L12.7197 11.2803ZM10.2803 10.2197C10.5732 10.5126 10.5732 10.9874 10.2803 11.2803L8.81066 12.75L10.2803 14.2197C10.5732 14.5126 10.5732 14.9874 10.2803 15.2803C9.98744 15.5732 9.51256 15.5732 9.21967 15.2803L7.21967 13.2803C6.92678 12.9874 6.92678 12.5126 7.21967 12.2197L9.21967 10.2197C9.51256 9.92678 9.98744 9.92678 10.2803 10.2197Z",
    fill: "#7b868c"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1139_885"
  }, /*#__PURE__*/React.createElement("rect", {
    color: "rgb(123, 134, 140)",
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.816945c9611bfbfb8a9117b6e07162fe.svg";
export { ForwardRef as ReactComponent };